import { platform } from "os";

export const footerPlatformContent = {
  en: {
    header: `Providing accessible, professional physiotherapy care online.
              Your movement, our priority.`,

    title1: "Services",
    store: "Store",
    platform:"Platform",

    title2: "Company",
    aboutUs: "About Us",
    ourTeam: "Our Team",
    careers: "Careers",
    blog: "Blog",
    home: "Home",

    title3: "Support",
    faqs: "FAQs",
    helpCenter: "Help Center",
    contactUs: "Contact Us",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",


    allRightsReserved: "© 2026 Revimo. All rights reserved.",
    privacy: "Privacy",
    terms: "Terms",
    cookies: "Cookies",
    accessibility: "Accessibility",
  },
  sl: {
    header: `Spletna fizioterapija, ki je dostopna in strokovna.
              Vaše zdravje, naša prednostna naloga.`,

    title1: "Storitve",
    store:"Trgovina",
    platform:"Platforma",

    title2: "Podjetje",
    aboutUs: "O nas",
    ourTeam: "Naša ekipa",
    careers: "Zaposlitev",
    blog: "Blog",
    home: "Domov",

    title3: "Podpora",
    faqs: "Pogosta vprašanja",
    helpCenter: "Center za pomoč",
    contactUs: "Kontakt",
    privacyPolicy: "Pravilnik o zasebnosti",
    termsOfService: "Pogoji uporabe",



    allRightsReserved: "© 2026 Revimo. Vse pravice pridržane.",
    privacy: "Zasebnost",
    terms: "Pogoji",
    cookies: "Piškotki",
    accessibility: "Dostopnost",
  },

} as const;